import qrAnalyticsTypes from "./qrAnalyticsTypes";
import { PENDING, SUCCESS, ERROR } from "../../globalStatuses/globalStatuses";

const initialState = {
    status: '',
    analytics: null,
}

const qrAnalyticsReducer = (state = initialState, action) => {
    switch (action.type) {
        case qrAnalyticsTypes.GET_QR_ANALYTICS_PENDING:
            return { ...state, status: PENDING }
        case qrAnalyticsTypes.GET_QR_ANALYTICS_SUCCESS:
            return { ...state, status: SUCCESS, analytics: action.payload }
        case qrAnalyticsTypes.GET_QR_ANALYTICS_ERROR:
            return { ...state, status: ERROR }
        default:
            return state
    }
}

export default qrAnalyticsReducer;
